export default __webpack_public_path__ + "static/media/helpIconHC.6af493ca.svg";